import request from '@/util/request.js';

// 全部商品
function all(url) {
    const baseApiUrl = url ? `${url}/api1.0/oig` : '/api1.0/oig';
    return request.get(baseApiUrl).then(response => {
        return response
    })
}

// 商品分类
function classification(id) {
    return request.get(`/api1.0/oig?oic_id=${id}`).then(response => {
        return response
    });
}

// 指定商品
function designated_product(id) {
    return request.get(`/api1.0/oig/${id}`).then(response => {
        return response
    });
}

// 搜索商品
function search(name) {
    return request.get(`/api1.0/oig?group_name_like=${name}`).then(response => {
        return response
    }).catch((error)=>{
        return false;
    });
}
// 获取子商品
function subcategory(id) {
    return request.get(`/api1.0/oi/sub?itemid=${id}`).then(response => {
        return response
    });
}

export default {
    all,
    classification,
    designated_product,
    search,
    subcategory
}